import Card from '@/components/card/card'
import { Divider, Empty, Input, List, Popup, Toast } from 'antd-mobile'
import styles from './AddBankAccount.module.scss'
import React, { useState, useEffect, useRef, useMemo } from 'react'
import { bankConfig } from '@/constants/bankConfig'
import { useSubCodeFruitStore } from '../store'
import * as apiCodeFruit from '@/subCodeFruit/apis';
import { REG_BANKACCOUNT, REG_PHONE } from '@/utils/regexp'
import { useDecoratorLock } from '@/hooks/useDecorator'
import SEARCH from './images/Search.svg'
import CLOSE from '@/assets/Close.svg'
import LINEICON from './images/lineIcon.svg'
import LINE from './images/line.svg'
import Up from '@/assets/Up.svg'
import { debounce } from '@/utils/common-js'
import env from '@/env'
import { navigateBack } from '@/utils/navigation'
import type { BankCardVO, ContractTempVO, marketing_loan_disbursement_protoco_item, marketing_loan_disbursement_protoco_response } from '../apis.type'
import BaseCheckBox from '@/components/form/BaseCheckbox'
import AgreementModal, { type AgreementModalRef } from '@/subCodeFruit/components/agreementModal/AgreementModal'
import { confirmModal } from '@/utils/confirmModal'
import BindModal, { type BindModalRef } from './components/bindModal/BindModal'
import { useLocation } from 'react-router-dom'
import { LinkShowEnum, ProtocolEnum } from '../apis.type'

interface BankListItem {
  label: string
  value: string
  disabled?: boolean
}
const AddBankAccount = () => {
  const location = useLocation()
  const [bankPickerVisible, setBankPickerVisible] = useState<boolean>(false)
  
  
  const [checked, setChecked] = useState<boolean>(false)
  const [time, setTime] = useState<number>(0)
  const [bankData, setBankData] = useState({
    bankAccountNumber: '',
    bankCode: '',
    mobile: '',
    verifyCode: '',
  })

  const setBankDataField = (key: keyof typeof bankData, value: (typeof bankData)[keyof typeof bankData]) => {
    setBankData((bankData) => ({
      ...bankData,
      [key]: value,
    }))
  }

  const [bankColumns, setBankColumns] = useState<BankListItem[]>([])

  const originalBankList = useRef<BankListItem[]>([])



  const agreementModalRef = React.useRef<AgreementModalRef>(null)

  const { bankAccountNumber, bankCode, mobile, verifyCode } = bankData

  // 获取合同模板列表
  const [contractTemplate, setContractTemplate] = useState<ContractTempVO>()
  const getContractTemplateList = async () => {
    const res = await apiCodeFruit.loan_order_contract_listContractTemp_contractType([
      apiCodeFruit.CONTRACT_TYPE.DEDUCTION_AUTHORIZATION, // 扣款授权协议
    ])
    setContractTemplate(res?.[0])
  }

  // 码果扣款协议
  const [codeFruitDeductionProtocol, setCodeFruitDeductionProtocol] = useState<marketing_loan_disbursement_protoco_item[]>([])
  const getCodeFruitDeductionProtocol = async () => {
    const res = await apiCodeFruit.marketing_loan_disbursement_protocol({
      protocolType: ProtocolEnum.WITHHOLD,
      linkShow: LinkShowEnum.BINDCARD,
      funderCode: useSubCodeFruitStore.getState().funderCode,
    })
    setCodeFruitDeductionProtocol(res || [])
  }

  const contractTemplateArr = useMemo(() => {
    let arr: marketing_loan_disbursement_protoco_response = []
    if (contractTemplate) {
      arr.push({
        protocolName: contractTemplate.contractTemplateName,
        url: contractTemplate.contractTemplateUrl,
      })
    }
    if (codeFruitDeductionProtocol.length > 0) {
      arr.push(...codeFruitDeductionProtocol)
    }
    return arr
  }, [contractTemplate, codeFruitDeductionProtocol])

    // 获取支持绑卡的银行卡列表
  const getSupportedBankCardList = async () => { 
    const res = await apiCodeFruit.userInfo_bankCard_getSupportBankList()
    let bankList = res.map(item => {
      return {
        label: item.bankName,
        value: item.bankCode,
      }
    })
    setBankColumns(bankList)
    originalBankList.current = bankList 
  }

  useEffect(() => {
    getContractTemplateList()
    // 获取支持绑卡的银行卡列表
    getSupportedBankCardList()
    getCodeFruitDeductionProtocol()
  }, [])

  useEffect(() => {
    if (time <= 0) {
      return
    }
    const timer = setTimeout(() => {
      setTime(time - 1)
    }, 1000)
    return () => clearTimeout(timer)
  }, [time])



  const formattedBankAccountNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/\D/g, '')
    // 限制最多19位数字
    const limited = raw.slice(0, 19)
    // 格式化显示：每4位加一个空格
    const formatted = limited.replace(/(\d{4})(?=\d)/g, '$1 ')
    setBankDataField('bankAccountNumber', raw) // 保存原始字符串值
    e.target.value = formatted // 更新输入框显示值
  }

  const handleCancel = () => {
    navigateBack()
  }

  // 选择银行
  const hendleSelectBank = () => {
    if (bindBankCard) {
      return
    }
    setBankPickerVisible(true)
  }
  // 输入手机号
  const handleInputMobile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 11)
    setBankDataField('mobile', value)
  }

  const sendVerifyCode = async () => {
    if (!mobile) {
      Toast.show({
        content: '请输入手机号',
      })
      return
    }
    if (!REG_PHONE.test(mobile)) {
      Toast.show({
        content: '请输入正确的手机号',
      })
      return
    }
    if (!bankAccountNumber || !REG_BANKACCOUNT.test(bankAccountNumber!.toString())) {
      Toast.show({
        content: '请输入正确的银行卡号',
      })
      return
    }
    if (time > 0) {
      return
    }
    await apiCodeFruit.userInfo_bankCard_verificationCode_add({
      bankCard: bankAccountNumber!.toString(),
      reservePhone: mobile,
    })
    setTime(60)
    Toast.show({
      content: '验证码已发送',
    })
  }

  const addBankAccount = async () => {
    if (!bankAccountNumber || !REG_BANKACCOUNT.test(bankAccountNumber!.toString())) {
      Toast.show({
        content: '请输入正确的银行卡号',
      })
      return
    }
    if (!bankCode) {
      Toast.show({
        content: '请选择银行',
      })
      return
    }
    if (!mobile) {
      Toast.show({
        content: '请输入手机号',
      })
      return
    }
    if (!REG_PHONE.test(mobile)) {
      Toast.show({
        content: '请输入正确的手机号',
      })
      return
    }
    handleAddBankAccount()
    // if (!verifyCode) {
    //   Toast.show({
    //     content: '请输入验证码',
    //   })
    //   return
    // }

    // if (!checked) {
    //   Toast.show({
    //     content: '请同意协议',
    //   })
    //   return
    // }
    
    // handleOpenAgreementModal(true)
  }
  const addBankAccountDecoratorLock = useDecoratorLock(addBankAccount)

  const handleSearchBank = debounce((e: string) => {
    if (!e) {
      setBankColumns(originalBankList.current)
      return
    }
    const searchBankColumns: BankListItem[] = []
    originalBankList.current.forEach((item) => {
      if (item.label.toLocaleLowerCase().includes(e.toLocaleLowerCase())) {
        searchBankColumns.push(item)
      }
    })
    setBankColumns(searchBankColumns)
  }, 500)

  
  const bindBankCard: BankCardVO | undefined = location.state?.bankCard
  useEffect(() => {
    console.log('bindBankCard',bindBankCard);
    if(bindBankCard && bankColumns.length > 0) {
      if (bankColumns.find(item => item.value === bindBankCard.bankCode)) {
        setBankData({
          bankAccountNumber: bindBankCard.bankCard || '',
          bankCode: bindBankCard.bankCode || '',
          mobile: bindBankCard.reservePhone || '',
          verifyCode: '',
        })
        // 用表单数据 + 接口返回的 id 构造 bankCardItem
        const bankCardItem = {
          id: bindBankCard.id,
          bankCard: bindBankCard.bankCard,
          bankName: bindBankCard.bankName,
          bankCode: bindBankCard.bankCode,
          reservePhone: bindBankCard.reservePhone,
          hasBindExternalType: false,
        }
        // 弹出验证码弹窗进行绑定
        handleBindBankCard(bankCardItem)
      } else {
        Toast.show({
          content: '不支持该银行卡',
        })
        navigateBack()
      }
    }
  }, [bindBankCard, bankColumns])

  const renderSearchBar = (
    <>
      <div className={styles.bankHeader}>
        <div className={styles.searchBankTitle}>所属银行</div>
        <img src={CLOSE} className={styles.closeIcon} onClick={() => setBankPickerVisible(false)} />
      </div>

      <div className={styles.searchBar}>
        <img src={SEARCH} className={styles.searchIcon} />
        <Input
          style={{
            '--font-size': '12px',
            width: '100%',
            border: 'none',
            minHeight: 0,
          }}
          onChange={handleSearchBank}
          placeholder="搜索"
        />
      </div>
    </>
  )

  const handleOnChangeBank = (bankId: string) => {
    setBankDataField('bankCode', bankId)
    setBankPickerVisible(false)
  }

  const handleOpenAgreementModal = (isSubmit?: boolean) => {
    agreementModalRef.current?.show(isSubmit)
  }

  const handleAddBankAccount = async () => {
    // 添加银行卡
    const bankCardId = await apiCodeFruit.userInfo_bankCard_add({
      bankCard: bankAccountNumber!.toString(),
      bankName: bankConfig[bankCode].name,
      reservePhone: mobile,
      bankCode: bankCode!,
      verificationCode: verifyCode!,
    })
    if (!bankCardId) {
      Toast.show({
        content: '添加银行卡失败',
      })
      return
    }

    // 用表单数据 + 接口返回的 id 构造 bankCardItem
    const bankCardItem = {
      id: bankCardId,  
      bankCard: bankAccountNumber,
      bankName: bankConfig[bankCode].name,
      bankCode: bankCode,
      reservePhone: mobile,
      hasBindExternalType: false,
    }

    // 弹出验证码弹窗进行绑定
    await handleBindBankCard(bankCardItem)
  }

  const onAgreementSuccess = async (isSubmit?: boolean) => {
    if (!isSubmit) {
      setChecked(true)
      agreementModalRef.current?.hide()
      return
    }
    navigateBack()
  }


  // 绑定银行卡（认证）
  const BindModalRef = useRef<BindModalRef>(null)

  const handleBindBankCard = async (bankCardItem: BankCardVO) => {
    return new Promise((resolve, reject) => {
      console.log('绑定银行卡', bankCardItem)
      BindModalRef.current?.show({
        bankCardItem,
        onSuccess: () => {
          // useSubCodeFruitStore.getState().getBankCardList()
          // BindModalRef.current?.hide()
          handleOpenAgreementModal(true)
          resolve(true)
        }
      })
    })
  }

  const openAgreementModal = () => {
    agreementModalRef.current?.show()
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.bankAccountMsg}>
        <Card>
          <div className={styles.bankAccountMsgTitle}>输入卡号添加</div>
          <Divider style={{ width: '100%' }} />
          <div className={styles.accountMsgItem}>
            <div className={styles.msgText}>卡号</div>
            <input
              style={{ border: 'none', outline: 'none', width: '100%' }}
              type="text"
              placeholder="请输入"
              disabled={bindBankCard ? true : false}
              value={bankAccountNumber?.toString().replace(/(\d{4})(?=\d)/g, '$1 ')}
              maxLength={23}
              inputMode="numeric"
              pattern="\d*"
              onChange={formattedBankAccountNumber}
            />
          </div>
          <Divider style={{ width: '100%' }} />
          <div className={styles.accountMsgItem} onClick={hendleSelectBank}>
            <div className={styles.msgText}>所属银行</div>
            <input
              style={{ border: 'none', outline: 'none', width: '100%' }}
              value={bankCode ? bankColumns.find((item) => item.value === bankCode)?.label : ''}
              placeholder="请选择"
              readOnly
              type="text"
            />
            <img src={Up} alt="select-bank" style={{ marginLeft: 8 }} />
          </div>
          <Divider style={{ width: '100%' }} />
          <div className={styles.accountMsgItem}>
            <div className={styles.msgText}>预留手机</div>
            <input
              style={{ border: 'none', outline: 'none', width: '100%' }}
              type="text"
              disabled={bindBankCard ? true : false}
              pattern="[0-9]*"
              maxLength={11}
              inputMode="numeric"
              value={mobile}
              placeholder="请输入"
              onChange={handleInputMobile}
            />
          </div>
          <Divider style={{ width: '100%' }} />
          <div className={styles.bottomButtons}>
            <button className={'outline ' + styles.cancelButton} onClick={handleCancel}>
              取消
            </button>
            <button className={`${styles.confirmButton}`} onClick={addBankAccountDecoratorLock}>
              确认添加
            </button>
          </div>
          {contractTemplateArr.length > 0 ? (
            <div className={styles.agreement}>
              <div onClick={() => setChecked(!checked)}>
                <BaseCheckBox value={checked} />
              </div>
              <div className={styles.agreementContent}>
                <span>
                  <span onClick={() => setChecked(!checked)}>已阅读并同意</span>
                  {
                    contractTemplateArr.map(item => (
                      <span
                        key={item.protocolName}
                        style={{ color: '#FF3B52' }}
                        onClick={() => handleOpenAgreementModal()}
                      >
                      《{item.protocolName}》
                      </span>
                    ))
                  }
                </span>
              </div>
            </div>
          ) : null}
          <Popup
            visible={bankPickerVisible}
            onMaskClick={() => {
              setBankPickerVisible(false)
            }}
            onClose={() => {
              setBankPickerVisible(false)
            }}
            bodyStyle={{ height: '600px' }}
            bodyClassName={styles.bankPicker}
          >
            <List header={renderSearchBar}>
              {bankColumns.length ? (
                bankColumns.map((column) => (
                  <List.Item
                    key={column.value}
                    arrowIcon={false}
                    disabled={column?.disabled}
                    onClick={() => handleOnChangeBank(column.value)}
                  >
                    {column.label + (column?.disabled ? ' (暂不支持，如有疑问可联系客服)' : '')}
                  </List.Item>
                ))
              ) : (
                <Empty description="暂无数据" />
              )}
            </List>
          </Popup>
        </Card>
      </div>
      <div className={styles.bottomPhone}>
        <span className={styles.bottomPhoneUpper}>
          <img className={styles.line} src={LINE}></img>
          <img style={{ verticalAlign: 'middle', marginLeft: '-2px' }} src={LINEICON} />
          <span style={{ marginLeft: '12px' }}>客服热线：</span>
          <span className={styles.phoneText} style={{ marginRight: '12px' }}>
            {env.customerHotline}
          </span>
          <img style={{ verticalAlign: 'middle', marginRight: '-2px' }} src={LINEICON} />
          <img className={styles.line} src={LINE} style={{ transform: 'rotate(180deg)' }}></img>
        </span>
        <span>粤ICP备2024240512号</span>
      </div>
      <AgreementModal ref={agreementModalRef} contractTemplateArr={contractTemplateArr} onSuccess={onAgreementSuccess} />
      <BindModal ref={ BindModalRef } openAgreementModal={openAgreementModal} contractTemplateArr={contractTemplateArr}/>
    </div>
  )
}

export default AddBankAccount
